<template>
  <div class="echartsPie">
    <div class="echartsTitle">
      <span v-if="isShowEchartsTitle">{{ echartsTitle }}</span>
      <div
        class="pie-icon"
        v-if="isShowOperate"
      >
        <i
          class="icon jlxk-home-download"
          @mouseenter="saveAsImgFlag = true"
          @mouseleave="saveAsImgFlag = false"
          @click="download"
        >
          <span v-show="saveAsImgFlag">保存图片</span>
        </i>
      </div>
    </div>
    <div
      class="reprint"
      :ref="`echartsPie${echartsId}`"
    />
  </div>
</template>

<script>
import { cyColors, downloadImg } from '@common/util.js'
import Echarts from 'echarts'
export default {
  props: {
    echartsId: {
      type: String,
      default: () => ''
    },
    isShowEchartsTitle: {
      type: Boolean,
      default: true
    },
    echartsTitle: {
      type: String,
      default: () => ''
    },
    dataList: {
      type: Array,
      default: () => []
    },
    color: {
      type: Array,
      default: () => cyColors()
    },
    isShowOperate: {
      type: Boolean,
      default: true
    },
    isShowLegend: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      saveAsImgFlag: false,
      myChart: null,
      grid: {
        top: 0
      },
      option: {
        color: [],
        tooltip: {
          trigger: 'item',
          formatter: '{b}：{c}&nbsp;&nbsp;{d}%'
        },
        legend: {
          orient: 'horizontal',
          bottom: 20,
          icon: 'circle',
          itemGap: 20,
          itemWidth: 8,
          textStyle: {
            fontFamily: 'FZYouHeiS',
            color: '#666'
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['23%', '42%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      }
    }
  },
  mounted() {
    this.myChart = Echarts.init(this.$refs[`echartsPie${this.echartsId}`])
  },
  methods: {
    drawLine() {
      this.myChart.clear()
      if (!this.isShowLegend) {
        this.option.legend = { show: false }
        this.option.series[0].label = { show: true, formatter: '{c}（{d}%）' }
        this.option.series[0].avoidLabelOverlap = true
        this.option.series[0].center = ['50%', '50%']
        this.option.series[0].labelLine = {
          show: true,
          lineStyle: { color: '#DDDDDD' }
        }
      }
      this.option.series[0].data = this.dataList
      this.option.color = this.color
      // 绘制图表
      this.myChart.setOption(this.option, true)
    },
    download() {
      let url = this.myChart.getDataURL({
        type: 'png',
        backgroundColor: '#ffffff'
      })
      downloadImg(url, this.echartsTitle)
    }
  },
  watch: {
    dataList: {
      handler() {
        this.drawLine()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.echartsPie {
  position: relative;
  width: 100%;
  height: 100%;
  .echartsTitle {
    position: relative;
    display: flex;
    align-items: center;
    height:32px;
    justify-content: space-between;
    padding: 16px 20px 0;
    font-size: 14px;
    color: #454647;
    .pie-icon {
      position: absolute;
      right: 20px;
      i {
        cursor: pointer;
        position: relative;
        & > span {
          position: absolute;
          width: 66px;
          font-size: 13px;
          color: #4497ec;
          top: 18px;
          font-style: initial;
          left: -18px;
          z-index: 10;
        }
        &:last-child {
          margin-left: 10px;
        }
      }
    }
  }
  .reprint {
    width: 100%;
    height: calc(100% - 32px);
  }
}
</style>
